export default [
    {
        path: '/yonghu/bscCustomer',
        component: () => import( '@/views/loud/yonghu/bscCustomer.vue'),
        meta: {
            title: '潜在客户',
            isTabsPage: true,
            requireAuth: true,
            keepAlive:true
        }
    },
    {
        path: '/yonghu/bscCustagent',
        component: () => import( '@/views/loud/yonghu/bscCustagent.vue'),
        meta: {
            title: '备用客户',
            isTabsPage: true,
            requireAuth: true,
            keepAlive:true
        }
    }
]
